export const ADD_TYPE_ID = 'addTypeId';
export const REORDER_TYPE_IDS = 'reorderTypeIds';
export const REMOVE_TYPE_ID = 'removeTypeId';


export const addTypeId = (payload) => ({
    type: ADD_TYPE_ID,
    payload
});

export const removeTypeId = (payload) => ({
    type: REMOVE_TYPE_ID,
    payload
});

export const reorderTypeIds = (payload) => ({
    type: REORDER_TYPE_IDS,
    payload
});

